import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { RejectBillingSupplyAuthorizationValidationSchema } from '@/features/supplyAuthorizations/schemas/reject.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseReviewBillingSupplyAuthorizationProps {
  supplyAuthorizationId?: string
  review: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useReviewBillingSupplyAuthorization = ({
  supplyAuthorizationId,
  review,
  onSuccess,
  onError,
}: UseReviewBillingSupplyAuthorizationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['reviewBillingSupplyAuthorization'],
    mutationFn: async (data?: RejectBillingSupplyAuthorizationValidationSchema) => {
      const supply_authorization = {
        reject_reason: data?.reject_reason,
      }

      return await privateAxios.put(`/billing/supply_authorizations/${supplyAuthorizationId}/${review}`, {
        supply_authorization,
      })
    },
    onSuccess,
    onError,
  })
}
